import script from "./cell.vue?vue&type=script&setup=true&lang=js"
export * from "./cell.vue?vue&type=script&setup=true&lang=js"

import "./cell.vue?vue&type=style&index=0&id=329f830b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-329f830b"]])

export default __exports__